import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ContentPage from 'src/components/ContentPage/ContentPage';
import FundsTable from '../components/FundsTable';
import useToggle from 'src/hooks/use-toggle';
import { Button, Icon, Spinner } from '@innovationnorway/cl-react';
import { useInnovationFunds } from '../hooks/use-innovation-funds';
import { useExternalServiceProvider } from 'src/features/actor-profile/hooks/use-external-service-provider';
const Details = () => {
  const { t: tCommon } = useTranslation();
  const { clusterId, year } = useParams();
  const { clusterEsaData, upsertESAData, clusterEsaQuery, sums } = useInnovationFunds(
    parseInt(year as string),
    clusterId as string,
  );
  const { serviceProvider, isFetching: fetchingProvider } = useExternalServiceProvider({
    serviceProviderId: clusterId!,
  });
  const { isActive, activate, deactivate } = useToggle(false);
  if (clusterEsaQuery.isFetching || fetchingProvider)
    return (
      <ContentPage title={serviceProvider?.name ?? ''}>
        <Spinner aria-label={tCommon('loading')} />
      </ContentPage>
    );
  return (
    <ContentPage title={serviceProvider?.name ?? ''} breadcrumbLeaf={serviceProvider?.name ?? undefined}>
      <>
        <div className="display--flex justify-content--flex-end">
          <Button type="button" variant="tertiary" onClick={activate}>
            <Icon prefix="fasr" iconName="edit" /> Rediger
          </Button>
        </div>
        <FundsTable
          editMode={!clusterEsaData || isActive}
          clusterEsaData={clusterEsaData}
          upsert={upsertESAData}
          deactivate={deactivate}
          sumOther={sums.other}
          sumPreInc={sums.preInc}
          sumAdministration={sums.administration}
          year={year}
        />
      </>
    </ContentPage>
  );
};
export default Details;
